// src/router/maps.js
import GalaxyMap from "@/views/maps/GalaxyMap.vue"; // 星系地图页面
import SolarSystem from "@/views/maps/solar-system/SolarSystem.vue"; // 太阳系页面
import VegaSystem from "@/views/maps/vega-system/VegaSystem.vue"; // 天女星系页面

export default [
  {
    path: "/galaxy-map", // 星系地图
    name: "GalaxyMap",
    component: GalaxyMap,
  },
  {
    path: "/galaxy-map/solar-system", // 太阳系
    name: "SolarSystem",
    component: SolarSystem,
  },
  {
    path: "/galaxy-map/vega-system", // 天女星系
    name: "VegaSystem",
    component: VegaSystem,
  },
];
